import { render, staticRenderFns } from "./NotificationSettingsTab.vue?vue&type=template&id=07c7cf03"
import script from "./NotificationSettingsTab.vue?vue&type=script&lang=js"
export * from "./NotificationSettingsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports